module.exports = __webpack_public_path__ + "static/media/whatsapp.f9ff6e10.svg";